import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback, useRef } from 'react';
import { QUERY_KEYS } from '@/query/queryKeys';
import { userService } from '../../services/userService';

const DEBOUNCE_DELAY = 500;

export const useSubmitPhoneVerifyCode = phone => {
  const queryClient = useQueryClient();
  const timerRef = useRef(null);
  const mutationRef = useRef(null);

  const mutation = useMutation({
    mutationFn: payload =>
      userService.phoneVerifySubmitCode(payload).then(response => {
        const { status, data } = response;
        if (status === 200) {
          queryClient.setQueryData([QUERY_KEYS.user.profile], prevData =>
            prevData
              ? { ...prevData, phone, is_phone_number_verified: true }
              : prevData,
          );
          return { success: true, data };
        }

        if (status === 422) {
          return { message: data.message }
        }

        return { message: 'Something went wrong' };
      }),
  });

  mutationRef.current = mutation;

  const debouncedMutateAsync = useCallback(
    payload =>
      new Promise((resolve, reject) => {
        clearTimeout(timerRef.current);
        timerRef.current = setTimeout(() => {
          mutationRef.current.mutateAsync(payload).then(resolve).catch(reject);
        }, DEBOUNCE_DELAY);
      }),
    [],
  );

  return { ...mutation, mutateAsync: debouncedMutateAsync };
};
